import type { EventEntityDTOWithId, LocalizedEventEntityDTO } from '@carlito/hotel-apis';

import { ControllerExecutionSuccessResult, ControllerQueryParameters } from '@carlito/ddd';
import type { ListEventsController } from '@carlito/hotel-apis';
import { bookitoRequest } from './api';

export type ListEventsQueryParameters<TShouldLocalize extends boolean = boolean> = Omit<
  ControllerQueryParameters<ListEventsController>,
  | 'excludeCancelled'
  | 'localize'
  | 'calculateParticipants'
  | 'includeHidden'
  | 'highlighted'
  | 'excludeNonBookable'
> & {
  localize?: TShouldLocalize;
  excludeCancelled?: boolean;
  calculateParticipants?: boolean;
  includeHidden?: boolean;
  highlighted?: boolean;
  excludeNonBookable?: boolean;
};

export type ListEventsResponse = ControllerExecutionSuccessResult<ListEventsController>;

export type ConditionallyLocalizedListEventsResponse<T extends boolean> = Omit<
  ListEventsResponse,
  'events'
> & {
  events: T extends true ? LocalizedEventEntityDTO[] : EventEntityDTOWithId[];
};

export async function listEvents<T extends boolean>(
  params: ListEventsQueryParameters<T>
): Promise<ConditionallyLocalizedListEventsResponse<T>> {
  const result = await bookitoRequest<ListEventsController>('/event', {
    queryParameters: {
      ...params,
      localize: params.localize ? 'true' : '',
      excludeCancelled: params.excludeCancelled ? 'true' : '',
      calculateParticipants: params.calculateParticipants ? 'true' : '',
      includeHidden: params.includeHidden === undefined ? '' : params.includeHidden.toString(),
      highlighted: params.highlighted ? 'true' : '',
      excludeNonBookable: params.excludeNonBookable ? 'true' : '',
    },
  });

  return result as ConditionallyLocalizedListEventsResponse<T>;
}
